module.exports = __webpack_public_path__ + "assets/green_check-b12a8e.svg";